<div [formGroup]="form" class="ea-loan-paliers">
  <pr-input-radio
    formControlName="paliersEnabled"
    label="Crédit à paliers"
    [toggleBgEmpty]="true"
    [options]="enabledOptions"
    [derrors]="derrors"
  ></pr-input-radio>

  <div [hidden]="!enabled">
    <pr-color-panel display="neutral" clazz="mbm">
      <pr-panel-body clazz="pam">
        <pr-label name="info_outline" [width]="18" [height]="18">
          La mensualité saisie est hors assurance (capital + intérêts). La
          mensualité du dernier palier est calculée automatiquement pour solder
          le prêt. Un différé se définit sur le 1<sup>er</sup> palier.
        </pr-label>
      </pr-panel-body>
    </pr-color-panel>

    @if (paliers) {
      <div formArrayName="paliers">
        @for (palier of paliers.controls; track palier; let i = $index) {
          <div
            class="palier-container"
            role="group"
            [attr.aria-label]="palierLabel(i)"
            [formGroupName]="i"
          >
            <div class="palier-header">
              <span class="palier-title">{{ palierLabel(i) }}</span>
              @if (canRemovePalier) {
                <pr-button
                  clazz="btn-nostyle neutral btn-list-remove"
                  leftIcon="sp-trash"
                  iconViewBoxWidth="23"
                  iconViewBoxHeight="23"
                  label="Supprimer"
                  [tooltip]="'Supprimer le palier ' + (i + 1)"
                  (onClick)="removePalier(i)"
                />
              }
            </div>

            <div>
              <pr-input
                label="Durée"
                suffix="Mois"
                [required]="true"
                [derrors]="derrors"
              >
                <input
                  formControlName="durationInMonth"
                  type="number"
                  min="1"
                  step="1"
                  placeholder="Ex : 96"
                />
              </pr-input>

              @if (i === 0) {
                <pr-input-radio
                  formControlName="differe"
                  label="Différé"
                  [toggleBgEmpty]="true"
                  [options]="differeOptions"
                  [derrors]="derrors"
                ></pr-input-radio>
              }

              @if (isDiffereRow(i)) {
                <pr-input label="Mensualité">
                  <input
                    type="text"
                    readonly
                    value="Différé — capital non amorti"
                  />
                </pr-input>
              } @else if (isLastPalier(i)) {
                <pr-input label="Mensualité (calculée)">
                  <input
                    type="text"
                    readonly
                    [value]="
                      showComputedMonthlyPayment(i)
                        ? (lastPalierMonthlyPayment
                          | currency: 'EUR' : 'symbol' : '.0-2')
                        : 'Calculée automatiquement'
                    "
                  />
                </pr-input>
              } @else {
                <pr-input
                  label="Mensualité hors assurance"
                  suffix="€"
                  [required]="true"
                  [derrors]="derrors"
                >
                  <input
                    formControlName="monthlyPayment"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="Ex : 800"
                  />
                </pr-input>
              }
            </div>
          </div>
        }
      </div>
    }

    <pr-button
      clazz="btn-list-add neutral"
      rightIcon="sp-plus"
      label="Ajouter un palier"
      [disabled]="!canAddPalier"
      (onClick)="addPalier()"
    ></pr-button>

    <p
      class="palier-sum"
      [class.is-valid]="sumMatches"
      [class.is-warning]="!sumMatches && !derrors"
      [class.is-bad]="!sumMatches && derrors"
    >
      <pr-icon
        class="palier-sum-icon"
        [name]="sumStatusIcon"
        [width]="16"
      ></pr-icon>
      <span>
        Somme des durées :
        <strong>{{ durationsSum }} / {{ totalDuration || '—' }} mois</strong>
      </span>
    </p>

    @if (previewBlockingReasons.length) {
      <ng-container
        [ngTemplateOutlet]="previewCallout"
        [ngTemplateOutletContext]="{
          title: previewUnavailableTitle,
          items: previewBlockingReasons,
          error: derrors,
        }"
      ></ng-container>
    }

    @if (previewErrorMessages.length) {
      <ng-container
        [ngTemplateOutlet]="previewCallout"
        [ngTemplateOutletContext]="{
          title: previewFailedTitle,
          items: previewErrorMessages,
          error: true,
        }"
      ></ng-container>
    }

    @if (previewCards.length) {
      <pr-cards [cards]="previewCards" clazz="mbm"></pr-cards>
    }

    @if (showPreviewSchedule) {
      <ea-loan-amortization
        headerTitle="Aperçu de l’échéancier"
        [emptyMessage]="previewEmptyMessage"
        [compact]="true"
        [steps]="previewSteps"
        [paliers]="previewPaliers"
        [loading]="previewLoading && !previewSteps"
      ></ea-loan-amortization>
    }
  </div>
</div>

<ng-template
  #previewCallout
  let-title="title"
  let-items="items"
  let-error="error"
>
  <div class="paliers-callout" [class.is-error]="error">
    <pr-icon
      class="paliers-callout-icon"
      [name]="error ? 'error_outline' : 'warning'"
      [width]="20"
    ></pr-icon>
    <div>
      <p class="paliers-callout-title">{{ title }}</p>
      <ul class="paliers-callout-list">
        @for (item of items; track item) {
          <li>{{ item }}</li>
        }
      </ul>
    </div>
  </div>
</ng-template>
